var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news_page"},[_c('DashHeader'),_c('NewsItems'),_c('p',[_c('router-link',{staticClass:"page_nav_button",attrs:{"to":"/"}},[_vm._v("Back Dashboard")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }